import React, { useRef } from "react";
import Container from "react-bootstrap/Container";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { IMAGES } from "../images/images";
import { Img, Section, Txt } from "../cms/Cms";

const Header = () => {
  const navbarToggleRef = useRef(null);
  const navbarCollapseRef = useRef(null);
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const scrollToSection = (id, event) => {
    // Some menu items are router <Link>s: stop their own navigation, which
    // would otherwise override ours (and keep the visitor on a sub-page).
    if (event) event.preventDefault();
    const el = document.getElementById(id);
    if (el && pathname === "/") {
      el.scrollIntoView({ behavior: "smooth" });
    } else {
      // On « Contact » or a legal page: go home, then to the section
      // (handled in App.js).
      navigate("/", { state: { scrollTo: id } });
    }

    // Toggle the collapse state of the navbar
    if (
      navbarToggleRef.current &&
      navbarCollapseRef.current.classList.contains("show")
    ) {
      navbarToggleRef.current.click();
    }
  };

  return (
    <Section id="header" label="Header">
      <Navbar collapseOnSelect expand="lg" id="home">
        <Container>
          <Navbar.Brand
            as={Link}
            to="/"
            data-aos="fade-right"
            data-aos-duration="1500"
          >
            <Img k="header_logo_img" src={IMAGES.Logo} width="100" slotWidth={262} slotHeight={148} label="Logo" />
          </Navbar.Brand>
          <Navbar.Toggle
            aria-controls="responsive-navbar-nav"
            ref={navbarToggleRef}
          />
          <Navbar.Collapse id="navbarScroll" ref={navbarCollapseRef}>
            <Nav className="ms-auto align-items-center">
              <Nav.Link
                data-aos="flip-left"
                data-aos-duration="2000"
                as={Link}
                to="/"
                onClick={(e) => scrollToSection("home", e)}
              >
                <Txt k="menu_home">Accueil</Txt>
              </Nav.Link>
              <Nav.Link
                data-aos="flip-left"
                data-aos-duration="2000"
                onClick={(e) => scrollToSection("aboutus", e)}
                as={Link}
              >
                <Txt k="menu_about">À propos de nous</Txt>
              </Nav.Link>
              <Nav.Link
                data-aos="flip-left"
                data-aos-duration="2000"
                onClick={(e) => scrollToSection("howitwork", e)}
              >
                <Txt k="menu_howitworks">Comment ça marche</Txt>
              </Nav.Link>
              <Nav.Link
                data-aos="flip-left"
                data-aos-duration="2000"
                onClick={(e) => scrollToSection("registeryourself", e)}
              >
                <Txt k="menu_join">Devenir membre fondateur</Txt>
              </Nav.Link>
              {/* <Nav.Link onClick={(e) => scrollToSection("registeryourself", e)}>
                Download Our Apps
              </Nav.Link> */}
              {/* <Nav.Link onClick={(e) => scrollToSection("downloadapp", e)}> */}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </Section>
  );
};

export default Header;
